import { useTranslation } from "react-i18next";
import { Link } from "~/components/ui/link";
import { Button } from "~/components/ui/button";
import { Picture } from "~/components/ui/picture";
import { cn } from "~/lib/utils";
import { imageUrl } from "~/lib/image-url";

// 16px bold CTAs, 52px tall: equal grid columns on mobile, 190px wide from lg.
const ctaClassName = "h-[52px] w-full px-4 py-4 text-base leading-5 tracking-[0.16px] lg:w-[190px] lg:px-6";

// Closing CTA over parked vans dimmed to 85% Bg-Primary. Must render inside the .fleet token scope.
export function FleetLastChance() {
  const { t } = useTranslation("fleet");

  return (
    <section aria-labelledby="fleet-last-chance-title" className="relative isolate overflow-hidden py-[60px]">
      <Picture
        src={imageUrl("/images/fleet/last-chance.jpg")}
        mobileSrc={imageUrl("/images/fleet/last-chance-mobile.jpg")}
        alt=""
        loading="lazy"
        className="absolute inset-0 -z-10 size-full object-cover"
      />
      <div aria-hidden className="absolute inset-0 -z-10 bg-[rgba(22,26,33,0.85)]" />
      <div className="wrap flex flex-col items-center gap-6 text-center">
        <div className="flex flex-col items-center gap-2 px-4 lg:gap-4 lg:px-0">
          <h2
            id="fleet-last-chance-title"
            className="font-display text-text-heading max-w-[273px] text-xl leading-7 font-extrabold lg:max-w-none lg:text-4xl lg:leading-[1.1]"
          >
            {t("last_chance.title")}
          </h2>
          <p className="text-text-body-secondary text-md leading-5">{t("last_chance.body")}</p>
        </div>
        <div className="grid w-full grid-cols-2 gap-3 lg:flex lg:w-auto">
          <Button asChild variant="primary-alt" className={cn(ctaClassName, "max-lg:order-last")}>
            <Link data-sid="fleet-last-chance-build-quote" to="/fleet/quote">{t("last_chance.build_quote")}</Link>
          </Button>
          <Button asChild variant="secondary-alt" className={ctaClassName}>
            <Link data-sid="fleet-last-chance-contact-sales" to="/contact">{t("last_chance.contact_sales")}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}

export default FleetLastChance;
